<template>
  <span
    v-tooltip="'Change Order'"
    @click="handleClick"
    style="cursor: pointer">
    <i class="fa fa-sort" aria-hidden="true">  
      {{ titleColumn }}
    </i>    
  </span>
</template>

<script lang="ts" setup>
      const props = defineProps<{
      titleColumn: string;
      sortByColum: string;
      setSorting: (column: string, direction: 'asc' | 'desc' | null) => void;
      sorting: { direction: 'asc' | 'desc' | null };
    }>();

    defineEmits<{
      (e: 'setSorting', column: string, direction: 'asc' | 'desc' | null): void;
    }>();

    const handleClick = () => {
      const newDirection = props.sorting.direction === 'asc' ? 'desc' : 'asc';
      props.setSorting(props.sortByColum, newDirection);
    };
</script>
